module.exports = __webpack_public_path__ + "static/media/ci_badge_small.7fcb9ad4.png";